import { useAxios } from 'api/useAxios';
import { DashboardEndPoint, EndPoint } from 'data/endPoint';
import {
    EsateRow,
    EstateChartResponse,
    EstateTableResponse,
    UserRow,
    UserTableResponse,
} from 'types/feature/dashboard/dashboard';
import { EstateResponse, UserResponse } from 'types/feature/ripeness/ripeness';

export const useDashboard = () => {
    const { api } = useAxios();

    const getEstateChartData = async (startDate: string, endDate: string, estateId: string | undefined) => {
        let url = `${DashboardEndPoint.estateChart.replace(':start', startDate).replace(':end', endDate)}`;
        if (estateId) {
            url = url + `&estate=${estateId}`;
        }
        return await api.get<EstateChartResponse>(url);
    };

    const getEstateTableData = async (startDate: string, endDate: string, estateId: string | undefined) => {
        let url = `${DashboardEndPoint.estateTable.replace(':start', startDate).replace(':end', endDate)}`;
        if (estateId) {
            url = url + `&estate=${estateId}`;
        }
        try {
            const result = await api.get<EstateTableResponse>(url);
            return result;
        } catch (e) {}
    };

    const getUserTableData = async (startDate: string, endDate: string, estateId: string | undefined) => {
        let url = `${DashboardEndPoint.userTable.replace(':start', startDate).replace(':end', endDate)}`;
        if (estateId) {
            url = url + `&estate=${estateId}`;
        }

        try {
            const result = await api.get<UserTableResponse>(url);

            return result;
        } catch (e) {}

        return await api.get<UserTableResponse>(url);
    };

    const getEstateListByDate = async (startDate: string, endDate: string) => {
        return await api.get<EstateTableResponse>(
            `${DashboardEndPoint.estateList.replace(':start', startDate).replace(':end', endDate)}`
        );
    };

    return { getEstateTableData, getEstateChartData, getUserTableData, getEstateListByDate };
};
